"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaFileExtension = exports.MediaContentType = void 0;
exports.isMediaContentType = isMediaContentType;
exports.getFileExtensionFromContentType = getFileExtensionFromContentType;
var MediaContentType;
(function (MediaContentType) {
    MediaContentType["PNG"] = "image/png";
    MediaContentType["JPEG"] = "image/jpeg";
    MediaContentType["JPG"] = "image/jpg";
    MediaContentType["WEBP"] = "image/webp";
    MediaContentType["GIF"] = "image/gif";
    MediaContentType["SVG"] = "image/svg+xml";
    MediaContentType["TIFF"] = "image/tiff";
    MediaContentType["BMP"] = "image/bmp";
    MediaContentType["AVIF"] = "image/avif";
    MediaContentType["HEIC"] = "image/heic";
    MediaContentType["MP3"] = "audio/mpeg";
    MediaContentType["MP3_LEGACY"] = "audio/mp3";
    MediaContentType["WAV"] = "audio/wav";
    MediaContentType["OGG"] = "audio/ogg";
    MediaContentType["OGA"] = "audio/oga";
    MediaContentType["AAC"] = "audio/aac";
    MediaContentType["M4A"] = "audio/mp4";
    MediaContentType["FLAC"] = "audio/flac";
    MediaContentType["OPUS"] = "audio/opus";
    MediaContentType["WEBA"] = "audio/webm";
    MediaContentType["MP4"] = "video/mp4";
    MediaContentType["WEBM"] = "video/webm";
    MediaContentType["VIDEO_OGG"] = "video/ogg";
    MediaContentType["MPEG"] = "video/mpeg";
    MediaContentType["MOV"] = "video/quicktime";
    MediaContentType["AVI"] = "video/x-msvideo";
    MediaContentType["MKV"] = "video/x-matroska";
    MediaContentType["TXT"] = "text/plain";
    MediaContentType["HTML"] = "text/html";
    MediaContentType["CSS"] = "text/css";
    MediaContentType["CSV"] = "text/csv";
    MediaContentType["MARKDOWN"] = "text/markdown";
    MediaContentType["PYTHON"] = "text/x-python";
    MediaContentType["JAVASCRIPT"] = "application/javascript";
    MediaContentType["TYPESCRIPT"] = "text/x-typescript";
    MediaContentType["YAML"] = "application/x-yaml";
    MediaContentType["PDF"] = "application/pdf";
    MediaContentType["DOC"] = "application/msword";
    MediaContentType["XLS"] = "application/vnd.ms-excel";
    MediaContentType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MediaContentType["ZIP"] = "application/zip";
    MediaContentType["JSON"] = "application/json";
    MediaContentType["XML"] = "application/xml";
    MediaContentType["BIN"] = "application/octet-stream";
    MediaContentType["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MediaContentType["PPTX"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    MediaContentType["RTF"] = "application/rtf";
    MediaContentType["JSONL"] = "application/x-ndjson";
    MediaContentType["PARQUET"] = "application/vnd.apache.parquet";
    MediaContentType["GZIP"] = "application/gzip";
    MediaContentType["TAR"] = "application/x-tar";
    MediaContentType["SEVEN_Z"] = "application/x-7z-compressed";
})(MediaContentType || (exports.MediaContentType = MediaContentType = {}));
var MediaFileExtension;
(function (MediaFileExtension) {
    MediaFileExtension["PNG"] = "png";
    MediaFileExtension["JPG"] = "jpg";
    MediaFileExtension["JPEG"] = "jpeg";
    MediaFileExtension["WEBP"] = "webp";
    MediaFileExtension["GIF"] = "gif";
    MediaFileExtension["SVG"] = "svg";
    MediaFileExtension["TIFF"] = "tiff";
    MediaFileExtension["BMP"] = "bmp";
    MediaFileExtension["AVIF"] = "avif";
    MediaFileExtension["HEIC"] = "heic";
    MediaFileExtension["MP3"] = "mp3";
    MediaFileExtension["WAV"] = "wav";
    MediaFileExtension["OGG"] = "ogg";
    MediaFileExtension["OGA"] = "oga";
    MediaFileExtension["AAC"] = "aac";
    MediaFileExtension["M4A"] = "m4a";
    MediaFileExtension["FLAC"] = "flac";
    MediaFileExtension["OPUS"] = "opus";
    MediaFileExtension["WEBA"] = "weba";
    MediaFileExtension["MP4"] = "mp4";
    MediaFileExtension["WEBM"] = "webm";
    MediaFileExtension["OGV"] = "ogv";
    MediaFileExtension["MPEG"] = "mpeg";
    MediaFileExtension["MOV"] = "mov";
    MediaFileExtension["AVI"] = "avi";
    MediaFileExtension["MKV"] = "mkv";
    MediaFileExtension["TXT"] = "txt";
    MediaFileExtension["HTML"] = "html";
    MediaFileExtension["CSS"] = "css";
    MediaFileExtension["CSV"] = "csv";
    MediaFileExtension["MD"] = "md";
    MediaFileExtension["PY"] = "py";
    MediaFileExtension["JS"] = "js";
    MediaFileExtension["TS"] = "ts";
    MediaFileExtension["YAML"] = "yaml";
    MediaFileExtension["PDF"] = "pdf";
    MediaFileExtension["DOC"] = "doc";
    MediaFileExtension["XLS"] = "xls";
    MediaFileExtension["XLSX"] = "xlsx";
    MediaFileExtension["ZIP"] = "zip";
    MediaFileExtension["JSON"] = "json";
    MediaFileExtension["XML"] = "xml";
    MediaFileExtension["BIN"] = "bin";
    MediaFileExtension["DOCX"] = "docx";
    MediaFileExtension["PPTX"] = "pptx";
    MediaFileExtension["RTF"] = "rtf";
    MediaFileExtension["JSONL"] = "jsonl";
    MediaFileExtension["PARQUET"] = "parquet";
    MediaFileExtension["GZ"] = "gz";
    MediaFileExtension["TAR"] = "tar";
    MediaFileExtension["SEVEN_Z"] = "7z";
})(MediaFileExtension || (exports.MediaFileExtension = MediaFileExtension = {}));
const mediaContentTypes = new Set(Object.values(MediaContentType));
function isMediaContentType(value) {
    return typeof value === "string" && mediaContentTypes.has(value);
}
function getFileExtensionFromContentType(contentType) {
    const mimeToExtension = {
        [MediaContentType.PNG]: MediaFileExtension.PNG,
        [MediaContentType.JPEG]: MediaFileExtension.JPEG,
        [MediaContentType.JPG]: MediaFileExtension.JPG,
        [MediaContentType.WEBP]: MediaFileExtension.WEBP,
        [MediaContentType.GIF]: MediaFileExtension.GIF,
        [MediaContentType.SVG]: MediaFileExtension.SVG,
        [MediaContentType.TIFF]: MediaFileExtension.TIFF,
        [MediaContentType.BMP]: MediaFileExtension.BMP,
        [MediaContentType.AVIF]: MediaFileExtension.AVIF,
        [MediaContentType.HEIC]: MediaFileExtension.HEIC,
        [MediaContentType.MP3]: MediaFileExtension.MP3,
        [MediaContentType.MP3_LEGACY]: MediaFileExtension.MP3,
        [MediaContentType.WAV]: MediaFileExtension.WAV,
        [MediaContentType.OGG]: MediaFileExtension.OGG,
        [MediaContentType.OGA]: MediaFileExtension.OGA,
        [MediaContentType.AAC]: MediaFileExtension.AAC,
        [MediaContentType.M4A]: MediaFileExtension.M4A,
        [MediaContentType.FLAC]: MediaFileExtension.FLAC,
        [MediaContentType.OPUS]: MediaFileExtension.OPUS,
        [MediaContentType.WEBA]: MediaFileExtension.WEBA,
        [MediaContentType.MP4]: MediaFileExtension.MP4,
        [MediaContentType.WEBM]: MediaFileExtension.WEBM,
        [MediaContentType.VIDEO_OGG]: MediaFileExtension.OGV,
        [MediaContentType.MPEG]: MediaFileExtension.MPEG,
        [MediaContentType.MOV]: MediaFileExtension.MOV,
        [MediaContentType.AVI]: MediaFileExtension.AVI,
        [MediaContentType.MKV]: MediaFileExtension.MKV,
        [MediaContentType.TXT]: MediaFileExtension.TXT,
        [MediaContentType.HTML]: MediaFileExtension.HTML,
        [MediaContentType.CSS]: MediaFileExtension.CSS,
        [MediaContentType.CSV]: MediaFileExtension.CSV,
        [MediaContentType.MARKDOWN]: MediaFileExtension.MD,
        [MediaContentType.PYTHON]: MediaFileExtension.PY,
        [MediaContentType.JAVASCRIPT]: MediaFileExtension.JS,
        [MediaContentType.TYPESCRIPT]: MediaFileExtension.TS,
        [MediaContentType.YAML]: MediaFileExtension.YAML,
        [MediaContentType.PDF]: MediaFileExtension.PDF,
        [MediaContentType.DOC]: MediaFileExtension.DOC,
        [MediaContentType.XLS]: MediaFileExtension.XLS,
        [MediaContentType.XLSX]: MediaFileExtension.XLSX,
        [MediaContentType.ZIP]: MediaFileExtension.ZIP,
        [MediaContentType.JSON]: MediaFileExtension.JSON,
        [MediaContentType.XML]: MediaFileExtension.XML,
        [MediaContentType.BIN]: MediaFileExtension.BIN,
        [MediaContentType.DOCX]: MediaFileExtension.DOCX,
        [MediaContentType.PPTX]: MediaFileExtension.PPTX,
        [MediaContentType.RTF]: MediaFileExtension.RTF,
        [MediaContentType.JSONL]: MediaFileExtension.JSONL,
        [MediaContentType.PARQUET]: MediaFileExtension.PARQUET,
        [MediaContentType.GZIP]: MediaFileExtension.GZ,
        [MediaContentType.TAR]: MediaFileExtension.TAR,
        [MediaContentType.SEVEN_Z]: MediaFileExtension.SEVEN_Z,
    };
    const extension = mimeToExtension[contentType];
    if (!extension) {
        throw new Error(`Unsupported content type: ${contentType}`);
    }
    return extension;
}
